@import "@/scss/use-bootstrap-mixins.scss";

.form {
  .inline {
    display: flex;
    flex-direction: row;
    gap: 6px;

    @include media-breakpoint-up(lg) {
      gap: 12px;
    }
  }

  .field {
    margin-bottom: 20px;

    span.header_text {
      color: $primaryOnBackground !important;
      margin: 0 !important;
      font-size: calc(1.3rem + 0.6vw);
      font-weight: 600 !important;
    }

    .box {
      background-color: #fff;
      border: 1px solid #e0e0e0;
      border-radius: 4px;
      padding: 12px 20px;
      display: flex;
      gap: 4px;
      align-items: center;
      width: 50%;
      justify-content: space-between;

      @include media-breakpoint-up(lg) {
        width: auto;
        gap: 12px;
      }

      &:hover {
        cursor: pointer;
      }

      span {
        font-size: 14px;
      }
    }

    .custom_checkbox {
      position: relative;
      width: 21px;
      height: 21px;

      label {
        background-color: #fff;
        width: 21px;
        height: 21px;
        border-radius: 11px;
        cursor: pointer;
        position: absolute;
        border: 1px solid #ccc;
        display: flex;
        justify-content: center;
        align-items: center;

        svg {
          color: #fff;
          opacity: 0;
        }
      }

      input[type="checkbox"] {
        display: none;

        &:checked + label {
          background-color: $primaryOnBackground;
          border-color: $primaryOnBackground;

          svg {
            opacity: 1;
          }
        }
      }
    }
  }

  .alternate_title {
    color: $primaryOnBackground !important;
    font-size: 16px;
    display: block;
  }

  .alternate_subtitle {
    color: #000 !important;
    font-size: 12px !important;
    font-style: italic !important;
    margin-bottom: 8px;
    display: block;
  }

  .same_address_row {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 12px;

    > label {
      font-size: 14px;
      cursor: pointer;
    }
  }

  label {
    font-size: 13px;
  }

  input,
  select,
  .datepicker {
    width: 100%;
    border: 1px solid #d0d0d0;
    border-radius: 4px !important;
    padding: 13px 15px;
    font-size: 14px;
    background-color: #fff;

    &:disabled {
      background-color: #f0f0f0;
      -webkit-animation: pulse 0.7s;
      -webkit-animation-iteration-count: 10;
      animation: pulse 0.7s;
      animation-iteration-count: 10;

      &.no_animation {
        animation: none;
        -webkit-animation: none;
      }
    }

    &.invalid {
      border-color: #d04d52;
    }

    @-webkit-keyframes pulse {
      from {
        border-color: #d0d0d0;
      }
      50% {
        border-color: $primary;
      }
      to {
        border-color: #d0d0d0;
      }
    }
    @keyframes pulse {
      from {
        border-color: #d0d0d0;
      }
      50% {
        border-color: $primary;
      }
      to {
        border-color: #d0d0d0;
      }
    }
  }

  // PhoneInput component styling to match other form fields
  :global(.react-international-phone-input-container) {
    width: 100%;
    display: flex;
    border: 1px solid #d0d0d0 !important;
    border-radius: 4px !important;
    background-color: #fff;
    box-shadow: none !important;

    &:focus-within {
      border-color: $primary !important;
    }

    :global(.react-international-phone-country-selector-button) {
      border: none !important;
      border-right: 1px solid #d0d0d0 !important;
      border-radius: 3px 0 0 3px !important;
      padding: 13px 12px !important;
      background: transparent !important;
      height: auto !important;
      margin: 0 !important;

      &:hover {
        background: #f5f5f5 !important;
      }

      &:focus {
        outline: none !important;
        box-shadow: none !important;
      }
    }

    :global(.react-international-phone-input) {
      width: 100% !important;
      flex: 1 !important;
      border: none !important;
      border-radius: 0 3px 3px 0 !important;
      padding: 13px 15px !important;
      font-size: 14px !important;
      background: transparent !important;
      height: auto !important;
      box-shadow: none !important;

      &:focus-visible,
      &:focus {
        outline: none !important;
        box-shadow: none !important;
      }

      &:disabled {
        background-color: #f0f0f0 !important;
      }
    }
  }

  .contact_row {
    display: flex;
    flex-direction: column;
    gap: 6px;
    margin-bottom: 6px;

    &:last-of-type {
      margin-bottom: 0;
    }

    @include media-breakpoint-up(lg) {
      flex-direction: row;
      gap: 12px;
      margin-bottom: 12px;
    }
  }


  .contact_row_1 {
    margin-top: 4px;

    select {
      flex-basis: 25%;
    }
  }

  .contact_row_commercial {
    span {
      display: block;
      font-size: 13px;
      margin-bottom: 12px;
    }

    .inner {
      display: flex;
      gap: 6px;
      margin-bottom: 6px;
      flex-direction: column;

      @include media-breakpoint-up(lg) {
        flex-direction: row;
        gap: 12px;
        margin-bottom: 12px;
      }
    }
  }

  .contact_row_2 {

    @include media-breakpoint-up(lg) {
      justify-content: space-between;
    }

    input {
      &:first-of-type {
        flex-basis: 25%;
      }
    }
  }

  .contact_row_3 {
    position: relative;

    input {
      &:first-of-type {
        flex-basis: 200%;
      }
    }

    .autocomplete_popup {
      position: absolute;
      top: 100%;
      left: 0;
      width: 100%;
      background-color: #fff;
      border: 1px solid #d0d0d0;
      border-top: none;
      border-radius: 0 0 4px 4px;
      z-index: 100;
      max-height: 200px;
      overflow-y: auto;
      display: block;

      span {
        padding: 2px 6px;
        cursor: pointer;
        display: block;
        color: #555 !important;
        font-size: 16px;

        &:hover {
          background-color: #f0f0f0;
          color: #333 !important;
        }
      }
    }
  }

  .contact_row_4 {
    display: flex;
    flex-direction: column;
    gap: 6px;
  }
}
